import NavigationProvider from 'dashboard-js/providers/NavigationProvider'

export default {
    mounted() {
        if (NavigationProvider.isRestored()) {
            NavigationProvider.restoreScroll()
        }
    },
}
